var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images && _vm.images.length > 0)?_c('div',{staticClass:"home-swip-img-box"},[_c('van-swipe',{attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.images),function(image,index){return _c('van-swipe-item',{key:index},[_c('img',{staticStyle:{"height":"180px","width":"100%"},attrs:{"src":image.img}})])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }